var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    d: "M3.5 4A1.5 1.5 0 0 1 5 2.5h18l7.5 8.625V35.5A1.5 1.5 0 0 1 29 37H5a1.5 1.5 0 0 1-1.5-1.5V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    stroke: "#888D96",
    strokeWidth: 0.75,
    d: "M8 .625h17.83l7.295 8.39V33.25c0 .621-.504 1.125-1.125 1.125H8a1.125 1.125 0 0 1-1.125-1.125V1.75c0-.621.504-1.125 1.125-1.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M7.25 22h13.875v3.75a1.5 1.5 0 0 1-1.5 1.5H7.25V22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 13.5,
    x: 0.875,
    y: 12.25,
    fill: "#F9961D",
    rx: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.664 21.875v-6.363h2.39c1.46 0 2.237.887 2.241 2.11-.004 1.216-.79 2.1-2.258 2.1h-1.23v2.153h-1.143Zm1.142-3.094h1.072c.862-.004 1.248-.487 1.248-1.16 0-.681-.386-1.151-1.248-1.151h-1.072v2.311ZM11.477 15.512v6.363h-1.143v-6.363h1.143ZM4.586 21.875v-.72l3.27-4.685H4.569v-.958h4.71v.712L6.01 20.908h3.287v.967h-4.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M26 .25v8.625h7.5L26 .25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D7DB",
    d: "M7.25 30.25H9.5v1.5H7.25v-1.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M18.5 30.25h3v1.5h-3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F636B",
    d: "M24.5 30.25h3v1.5h-3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D7DB",
    d: "M12.5 30.25h3v1.5h-3zM9.5 31.75h3v1.5h-3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M15.5 31.75h3v1.5h-3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M21.5 31.75h3v1.5h-3z"
  })));
};
export default SvgZip;